/**
 * User role constants
 * @description Defines all possible user roles in the system
 */
export const USER_ROLES = {
	SUPER_ADMIN: "super_admin",
	ASSISTANT_DIRECTOR: "assistant_director",
	DEPUTY_DIRECTOR: "deputy_director",
	DIRECTOR: "director",
	ADDITIONAL_DIRECTOR: "additional_director",
	DIRECTOR_GENERAL: "director_general",
} as const;

/**
 * Type for user roles
 */
export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

/**
 * Permission constants
 * @description Defines known permissions for TypeScript type safety
 * Note: The system is dynamic and will work with any new permissions from API
 */
export const PERMISSIONS = {
	// Application permissions
	APPLICATION_HISTORY_LIST: "application.read",
	APPLICATION_SCRUTINIZED_LIST: "application.scrutinized.list",
	APPLICATION_COMMITTEE_CONSTITUTE: "application.committee.constitute",
	APPLICATION_SCRUTINIZE: "application.scrutinize",

	// Committee permissions
	COMMITTEE_LIST: "committee.list",
	COMMITTEE_READ: "committee.read",
	COMMITTEE_APPROVE: "committee.approve",
	COMMITTEE_REJECT: "committee.reject",
	COMMITTEE_FINALIZE: "committee.finalize",
	COMMITTEE_APPROVED_READ: "committee.approved.read",
	COMMITTEE_APPROVED_LIST: "committee.approved.list",

	// Certificate permissions
	CERTIFICATE_ISSUE: "certificate.issue",

	// Audit permissions
	AUDIT_LIST_READ: "audit.list.read",

	// General permissions
	ALL_READ: "all.read",
} as const;

/**
 * Type for permissions - allows any string for dynamic API permissions
 */
export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS] | string;
